/**
 * Blog Buy Now Button Auto-Detection - FIXED VERSION
 * Shows maximum 3 unique products with container styling
 * Eliminates duplicate products
 */

class BlogBuyNow {
  constructor() {
    this.init();
  }

  init() {
    if (document.querySelector('.article-content')) {
      this.processBlogContent();
    }
  }

  // Product mapping for your ACTUAL spice products from Nilgiri Marten
  getProductMappings() {
    return {
      // Main Spice Products (VERIFIED from your theme)
      'black pepper': 'tellicherry-black-pepper',
      'tellicherry pepper': 'tellicherry-black-pepper',
      'tellicherry black pepper': 'tellicherry-black-pepper',
      'pepper': 'tellicherry-black-pepper',
      
      'cardamom': 'idukki-idukki-green-cardamom',
      'green cardamom': 'idukki-idukki-green-cardamom',
      'idukki cardamom': 'idukki-idukki-green-cardamom',
      
      'cloves': 'kanniyakumari-cloves',
      'kanniyakumari cloves': 'kanniyakumari-cloves',
      
      'ginger': 'ing-makhir-ginger-powder',
      'ginger powder': 'ing-makhir-ginger-powder',
      'makhir ginger': 'ing-makhir-ginger-powder',
      'ing makhir ginger': 'ing-makhir-ginger-powder',
      
      'turmeric': 'lakadong-turmeric-powder',
      'turmeric powder': 'lakadong-turmeric-powder',
      'lakadong turmeric': 'lakadong-turmeric-powder',
      'lakadong': 'lakadong-turmeric-powder',
      
      // Regional variations
      'nilgiri spices': 'tellicherry-black-pepper', // Default to main product
      'single origin spices': 'tellicherry-black-pepper',
      'gi tagged spices': 'tellicherry-black-pepper',
      
      // Other products found in theme
      'gift wrap': 'gift-wrap',
      'gift wrapping': 'gift-wrap',
      
      // Collection shortcuts (will redirect to collections)
      'ethereal northeast': 'ethereal-northeast-collection',
      'misty meghalaya': 'misty-meghalaya-collection',
      'baking essentials': 'baking-essentials-collection',
      'spice symphony': 'spice-symphony-south-collection',
      
      // Add more regional or product-specific terms as needed
    };
  }

  // Get display names for products
  getProductDisplayNames() {
    return {
      'tellicherry-black-pepper': 'Black Pepper',
      'idukki-idukki-green-cardamom': 'Cardamom',
      'kanniyakumari-cloves': 'Cloves',
      'ing-makhir-ginger-powder': 'Ginger',
      'lakadong-turmeric-powder': 'Turmeric',
      'gift-wrap': 'Gift Wrap'
    };
  }

  processBlogContent() {
    const articleContent = document.querySelector('.article-content');
    if (!articleContent) return;

    const productMappings = this.getProductMappings();
    const displayNames = this.getProductDisplayNames();
    const foundProducts = new Map(); // Use Map to avoid duplicates

    // Check entire article content for product mentions
    Object.entries(productMappings).forEach(([searchTerm, productHandle]) => {
      const regex = new RegExp(`\\b${searchTerm}\\b`, 'gi');
      const articleText = articleContent.textContent.toLowerCase();
      
      if (articleText.includes(searchTerm.toLowerCase())) {
        // Only add if we don't already have this product
        if (!foundProducts.has(productHandle)) {
          const displayName = displayNames[productHandle] || searchTerm;
          foundProducts.set(productHandle, displayName);
        }
      }
    });

    // Limit to maximum 3 unique products
    const uniqueProducts = Array.from(foundProducts.entries()).slice(0, 3);

    // Add buttons at the end of the article if we found products
    if (uniqueProducts.length > 0) {
      this.addBuyNowButtonsAtEnd(articleContent, uniqueProducts);
    }
  }

  addBuyNowButtonsAtEnd(articleContent, products) {
    // Create container for all buy now buttons
    const buttonsHTML = `
      <div class="blog-buy-now-section">
        ${products.map(([productHandle, displayName]) => `
          <div class="blog-buy-now-auto" data-product="${productHandle}">
            <div class="alert alert-info d-flex align-items-center">
              <div class="me-3">
                <i class="bi bi-cart-plus-fill"></i>
              </div>
              <div class="flex-grow-1">
                <strong>Interested in ${displayName}?</strong>
                <p class="mb-0">Get premium quality ${displayName.toLowerCase()} delivered to your doorstep!</p>
              </div>
              <div class="ms-3">
                <a href="/products/${productHandle}" class="btn">
                  Shop Now
                </a>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    `;

    // Append to the end of article content
    articleContent.insertAdjacentHTML('beforeend', buttonsHTML);
  }

  // Method to manually add buy now button (for use in blog posts)
  static addButton(productHandle, buttonText = 'Shop Now', afterSelector = null) {
    const target = afterSelector ? document.querySelector(afterSelector) : document.querySelector('.article-content');
    
    if (target) {
      const buttonHTML = `
        <div class="blog-buy-now-manual" data-product="${productHandle}">
          <div class="alert alert-info d-flex align-items-center">
            <div class="me-3">
              <i class="bi bi-cart-plus-fill"></i>
            </div>
            <div class="flex-grow-1">
              <strong>Premium Quality Product</strong>
              <p class="mb-0">Get this product delivered to your doorstep!</p>
            </div>
            <div class="ms-3">
              <a href="/products/${productHandle}" class="btn">
                ${buttonText}
              </a>
            </div>
          </div>
        </div>
      `;
      target.insertAdjacentHTML('beforeend', buttonHTML);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  new BlogBuyNow();
});

// Make the manual add function globally available
window.BlogBuyNow = BlogBuyNow;